import createConverter from './lib/create_converter';
import Topic from 'models/topic';

export default createConverter(Topic);
